<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <el-tabs v-model="table.query.state" @tab-click="search(true)">
          <el-tab-pane label="全部房间" name="-1"></el-tab-pane>
          <el-tab-pane label="空置房间" name="4"></el-tab-pane>
        </el-tabs>
        <div class="lr between">
          <div style="display: flex;justify-content: space-between;">
            <el-input style="width: 217px;" v-model="table.query.keyWord" placeholder="请输入关键字查询" clearable
                      suffix-icon="el-icon-search" @change="search(false)"/>
            <div class="ml20">
              <el-select filterable  v-model="table.query.houseId" placeholder="请选择房源" clearable @change="search(true)">
                <el-option v-for="item in houses" :key="item.id" :value="item.id"
                           :label="item.name"></el-option>
              </el-select>
            </div>
            <div class="ml20">
              <el-date-picker
                v-model="table.query.startYear"
                type="year"
                placeholder="请选择空置年份"
                @change="search(true)"
                value-format="yyyy"
              >
              </el-date-picker>
            </div>
          </div>
          <div style="display: flex;justify-content: flex-end;">
            <el-button type="primary" size="small" @click="openDialog(null, false)"
                       icon="el-icon-plus">新增
            </el-button>
            <el-button type="primary" size="small" @click="openHouseTypeDialog"
                       icon="el-icon-plus" v-if="isAdmin">户型
            </el-button>
            <el-button type="primary" size="small" @click="handleExcelExport"
                       icon="el-icon-download" class="ml20">导出
            </el-button>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="名称" align="center"
                             prop="name"></el-table-column>
            <el-table-column show-overflow-tooltip label="小区" align="center"
                             prop="communityName"></el-table-column>
            <el-table-column show-overflow-tooltip label="房源" align="center"
                             prop="houseName"></el-table-column>
            <el-table-column show-overflow-tooltip label="管理员" align="center"
                             prop="nowAdminName"></el-table-column>
            <el-table-column show-overflow-tooltip label="房间号" align="center"
                             prop="code"></el-table-column>
            <el-table-column show-overflow-tooltip label="创建日期" align="center"
                             prop="createDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="户型" align="center"
                             prop="houseTypeName"></el-table-column>
            <el-table-column show-overflow-tooltip label="定价" align="center"
                             prop="price"></el-table-column>
            <el-table-column show-overflow-tooltip label="在租价格" align="center"
                             prop="nowContractPrice">
            </el-table-column>
            <el-table-column show-overflow-tooltip label="在租合同" align="center"
                             prop="nowContractDate">
            </el-table-column>
            <el-table-column show-overflow-tooltip label="付款方式" align="center"
                             prop="nowContractType">
              <template slot-scope="scope">
                <span v-if="scope.row.nowContractType == 0">月付</span>
                <span v-if="scope.row.nowContractType == 4">两月付</span>
                <span v-else-if="scope.row.nowContractType == 1">季付</span>
                <span v-else-if="scope.row.nowContractType == 2">半年付</span>
                <span v-else-if="scope.row.nowContractType == 3">年付</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="状态" align="center"
                             prop="state">
              <template slot-scope="scope">
                <span v-if="scope.row.state == 0">空置</span>
                <span v-if="scope.row.state == 1">预订</span>
                <span v-if="scope.row.state == 2">在租</span>
                <span v-if="scope.row.state == 3">装修</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="当前空置天数" align="center" width="130"
                             prop="freeDay">
              <template slot-scope="scope">
                <span v-if="scope.row.freeDay <= 7">{{scope.row.freeDay}}</span>
                <span v-else style="color: red;">{{scope.row.freeDay}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="年总空置天数" width="130" align="center"
                             prop="yearFreeDay">
              <template slot-scope="scope">
                <span v-if="scope.row.yearFreeDay <= 7">{{scope.row.yearFreeDay}}</span>
                <span v-else style="color: red;">{{scope.row.yearFreeDay}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="description"></el-table-column>
            <el-table-column show-overflow-tooltip label="排序值" align="center"
                             prop="sort"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="260" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="playVideo(scope.row)" :disabled="!scope.row.videoUrls">视频</el-button>
                <el-button type="text" @click="openDialog(scope.row, true)">编辑</el-button>
                <el-button type="text" @click="toDetail(scope.row)">出租明细</el-button>
                <el-button type="text" style="color: #ff4949;" @click="deleteData(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="roomDialog.visible" :close-on-click-modal="false" width="40%"
               :title="!isEdit ? '新增房间' : '编辑房间'">
      <el-form ref="roomForm" label-position="right" label-width="100px" :model="roomDialog.formData"
               :rules="rules" style="height: 550px;overflow-y: auto;padding: 0 20px;">
        <el-form-item label="房源：" prop="houseId">
          <el-select filterable  v-model="roomDialog.formData.houseId" placeholder="请选择房源" clearable style="width: 100%;">
            <el-option v-for="item in houses" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="户型：" prop="houseTypeId">
          <el-select filterable  v-model="roomDialog.formData.houseTypeId" placeholder="请选择户型" clearable style="width: 100%;">
            <el-option v-for="item in houseTypes" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房间号：" prop="code">
          <el-input placeholder="请输入房间号" v-model="roomDialog.formData.code" clearable/>
        </el-form-item>
        <el-form-item label="创建日期：" prop="createDate">
          <el-date-picker
            v-model="roomDialog.formData.createDate"
            type="date"
            placeholder="请选择创建日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="定价：" prop="price">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%" v-model="roomDialog.formData.price"
                           clearable/>
        </el-form-item>
        <el-form-item label="状态：" prop="state">
          <el-select filterable  v-model="roomDialog.formData.state" placeholder="请选择状态" clearable style="width: 100%;">
            <el-option v-for="item in states" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图片：">
          <el-upload
            action="/group1/upload?output=json"
            list-type="picture-card"
            :limit="3"
            :file-list="imageList"
            :on-success="handleImageSuccess"
            :on-remove="handleImageRemove"
            accept="image/gif,image/jpeg,image/png,.gif,.jpeg,.jpg,.png">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频：">
          <el-upload
            action="/group1/upload?output=json"
            class="upload-demo"
            drag
            multiple
            :limit="1"
            :file-list="videoList"
            :on-success="handleVideoSuccess"
            :on-remove="handleVideoRemove"
            accept="video/*">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="roomDialog.formData.description"></el-input>
        </el-form-item>
        <el-form-item label="排序值：" prop="sort">
          <el-input-number style="width: 100%;" :min="0" v-model="roomDialog.formData.sort"></el-input-number>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="roomDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateData" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="videoDialog.visible" :close-on-click-modal="false" width="40%" title="视频">
      <video-player :mp4Url="videoDialog.url"></video-player>
      <div class="dialog-btn">
        <el-button @click="videoDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="downLoadVideo">下载</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="houseTypeDialog.visible" :close-on-click-modal="false" width="40%" title="户型">
      <house-type></house-type>
    </el-dialog>
  </div>
</template>
<script>

import {getPageList, deleteData, saveOrUpdateData} from "@/api/room";
import {getList as getHouses} from "@/api/house";
import {getList as getAdmins} from "@/api/user";
import {getList as getHouseTypes} from "@/api/houseType";
import VideoPlayer from '@/components/Video';
import HouseType from '@/components/HouseType';

export default {
  components:{
    VideoPlayer,
    HouseType
  },
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          keyWord: '',
          houseId: '',
          state: '-1',
          startYear: ''
        },
        total: 0,
        data: []
      },
      roomDialog: {
        formData: {
          houseId: '',
          houseName: '',
          houseTypeId: '',
          houseTypeName: '',
          adminId: '',
          adminName: '',
          createDate: '',
          code: '',
          name: '',
          price: 0,
          imageUrls: '',
          videoUrls: '',
          address: '',
          description: '',
          sort: 0
        },
        visible: false
      },
      rules: {
        houseId: [
          {trigger: 'change', required: true, message: '请选择房源'}
        ],
        houseTypeId: [
          {trigger: 'change', required: true, message: '请选择户型'}
        ],
        adminId: [
          {trigger: 'change', required: true, message: '请选择管理员'}
        ],
        createDate: [
          {trigger: 'change', required: true, message: '请选择创建日期'}
        ],
        code: [
          {trigger: 'blur', required: true, message: '请输入房间号'}
        ],
        price: [
          {trigger: 'blur', required: true, message: '请输入定价'}
        ],
        state: [
          {trigger: 'blur', required: true, message: '请选择状态'}
        ],
        imageUrls: [
          {trigger: 'blur', required: true, message: '请上传图片'}
        ],
        address: [
          {trigger: 'blur', required: true, message: '请输入详细地址'}
        ],
        description: [
          {trigger: 'blur', required: true, message: '请输入备注'}
        ],
        sort: [
          {trigger: 'blur', required: true, message: '请输入排序值'}
        ]
      },
      loading: false,
      tableLoading: false,
      isEdit: false,
      imageList: [],
      videoList: [],
      houses: [],
      admins: [],
      states: [
        {
          id: 0,
          name: '空置'
        },
        {
          id: 1,
          name: '预订'
        },
        {
          id: 2,
          name: '在租'
        },
        {
          id: 3,
          name: '装修'
        }
      ],
      userInfo: {},
      videoDialog: {
        url: '',
        visible: false
      },
      houseTypeDialog: {
        visible: false
      },
      isAdmin: false,
      houseTypes: [],
      cancel: false
    }
  },
  mounted() {
    let id = this.$route.query.id
    const name = this.$route.query.name
    this.cancel = this.$route.query.cancel
    if (id) {
      id = parseInt(id)
      this.roomDialog.formData.houseId = id
      this.roomDialog.formData.houseName = name
      this.table.query.houseId = id
    }
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.table.query.startYear = new Date().getFullYear() + ''
    this.search(true)
    this.getHouses()
    this.getAdmins()
    this.isAdmin = this.userInfo.roleIds.indexOf('1') != -1
  },
  methods: {
    getHouses() {
      getHouses().then(response => {
        if (response.code == 200) {
          // 查询成功
          this.houses = response.data
        }
      })
    },
    getAdmins() {
      const params = {
        roleIds: '2,5'
      }
      getAdmins(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.admins = response.data
        }
      })
    },
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      let state = '';
      if (flag) {
        this.table.query.page = 1
        this.table.query.keyWord = ''
      }
      if (this.table.query.state != -1) {
        state = this.table.query.state
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
        houseId: this.table.query.houseId,
        startYear: this.table.query.startYear,
        state: state,
        cancel: this.cancel
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 修改房间
    saveOrUpdateData() {
      this.loading = true
      this.$refs['roomForm'].validate(async (valid) => {
        if (valid) {
          this.roomDialog.formData.houseName = this.houses.filter(item => item.id == this.roomDialog.formData.houseId)[0].name
          // this.roomDialog.formData.adminName = this.admins.filter(item => item.id == this.roomDialog.formData.adminId)[0].nickname
          this.roomDialog.formData.houseTypeName = this.houseTypes.filter(item => item.id == this.roomDialog.formData.houseTypeId)[0].name
          if (!this.roomDialog.formData.createPerson) {
            this.roomDialog.formData.createPerson = this.userInfo.nickname
            this.roomDialog.formData.createRole = this.userInfo.roleIds
            this.roomDialog.formData.createFrom = 0
          }
          saveOrUpdateData(this.roomDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.roomDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openDialog(data, isEdit) {
      this.isEdit = isEdit
      this.imageList = []
      this.videoList = []
      this.houseTypes = []
      getHouseTypes(this.roomDialog.formData).then(response => {
        this.houseTypes = response.data
        if (!isEdit) {
          const houseId = this.roomDialog.formData.houseId
          const houseName = this.roomDialog.formData.houseName
          // 重置数据
          this.roomDialog.formData = {
            houseId: '',
            houseName: '',
            adminId: '',
            adminName: '',
            code: '',
            createDate: '',
            name: '',
            price: 0,
            payType: '',
            imageUrls: '',
            videoUrls: '',
            address: '',
            description: '',
            sort: 0
          }
          if (houseId) {
            this.roomDialog.formData.houseId = houseId
            this.roomDialog.formData.houseName = houseName
          }
        } else {
          if (data.imageUrls) {
            const imageUrls = data.imageUrls.split(',')
            for (let i = 0; i < imageUrls.length; i++) {
              this.imageList.push({
                uid: i,
                url: imageUrls[i]
              })
            }
          }
          if (data.videoUrls) {
            const videoUrls = data.videoUrls.split(',')
            for (let i = 0; i < videoUrls.length; i++) {
              this.videoList.push({
                uid: i,
                url: videoUrls[i]
              })
            }
          }
          this.roomDialog.formData = JSON.parse(JSON.stringify(data))
        }
        this.roomDialog.visible = true
        // 清空验证信息
        this.$nextTick(() => {
          this.$refs.roomForm.clearValidate()
        })
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    // 删除房间
    deleteData(id) {
      this.$confirm('此操作将永久删除房间信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData(id).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error(response.data)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleImageSuccess(response, file) {
      this.imageList.push({
        uid: file.uid,
        url: response.url
      })
      this.roomDialog.formData.imageUrls = this.imageList.map(item => item.url).join(',')
    },
    handleImageRemove(file) {
      this.imageList = this.imageList.filter(item => item.uid != file.uid)
      if (this.imageList && this.imageList.length > 0) {
        this.roomDialog.formData.imageUrls = this.imageList.map(item => item.url).join(',')
      } else {
        this.roomDialog.formData.imageUrls = ''
      }
    },
    handleVideoSuccess(response, file) {
      this.videoList.push({
        uid: file.uid,
        url: response.url,
        name: response.url.substr(response.url.lastIndexOf('/') + 1)
      })
      this.roomDialog.formData.videoUrls = this.videoList.map(item => item.url).join(',')
    },
    handleVideoRemove(file) {
      this.videoList = this.videoList.filter(item => item.uid != file.uid)
      if (this.videoList && this.videoList.length > 0) {
        this.roomDialog.formData.videoUrls = this.videoList.map(item => item.url).join(',')
      } else {
        this.roomDialog.formData.videoUrls = ''
      }
    },
    toDetail(row) {
      this.$router.push('/roomDetail?roomId=' + row.id)
    },
    playVideo(row) {
      this.videoDialog.url = row.videoUrls
      this.videoDialog.visible = true
    },
    downLoadVideo() {
      window.open(this.videoDialog.url)
    },
    //导出
    handleExcelExport() {
      window.open("/hrApi/room/export?houseId="  + this.table.query.houseId + "&token=" + localStorage.getItem("token"));
      this.$message.success("导出成功！");
    },
    openHouseTypeDialog() {
      this.houseTypeDialog.visible = true
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/back/room.vue